import { SectionShell, Field } from "./SectionShell";
import { Input } from "../ui/input";
import { inputCls } from "./constants";

export default function ClientTab({ data, update }) {
  return (
    <SectionShell eyebrow="Identification" title="Client Details">
      <div className="grid md:grid-cols-2 gap-6">
        <Field label="Client Name"><Input data-testid="client-name" className={inputCls} value={data.client_name || ""} onChange={(e) => update({ client_name: e.target.value })} /></Field>
        <Field label="Business Name"><Input data-testid="business-name" className={inputCls} value={data.business_name || ""} onChange={(e) => update({ business_name: e.target.value })} /></Field>
        <Field label="Industry"><Input data-testid="industry" className={inputCls} value={data.industry || ""} onChange={(e) => update({ industry: e.target.value })} /></Field>
        <Field label="Client's Role"><Input data-testid="client-role" className={inputCls} value={data.client_role || ""} onChange={(e) => update({ client_role: e.target.value })} /></Field>
        <Field label="Team Size"><Input data-testid="team-size" className={inputCls} value={data.team_size || ""} onChange={(e) => update({ team_size: e.target.value })} /></Field>
        <Field label="Interview Date"><Input data-testid="interview-date" type="date" className={inputCls} value={data.interview_date || ""} onChange={(e) => update({ interview_date: e.target.value })} /></Field>
      </div>
    </SectionShell>
  );
}
